import { inject, Injectable, Injector } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { LearningUnitEntity } from '../learning-unit-entity';
import { ModuleEntity } from '../../module/module.entity';
import { LearningSectionEntityService } from '../../learning-section/services/learning-section.entity.service';
import { ModuleEntityService } from '../../module/services/module.entity.service';

export const STATE_NAME = 'learningUnitEntity';

export const LearningUnitEntityState: GenericEntityStateClass<LearningUnitEntity> =
  createEntityState<LearningUnitEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class LearningUnitEntityService extends EntityService<LearningUnitEntity> {
  private injector = inject(Injector);
  private learningSectionService = inject(LearningSectionEntityService);

  constructor() {
    super();
    this.resourceType = 'learning-units';
    this.stateClass = LearningUnitEntityState;

    this.registerRelation('learning-sections', this.learningSectionService);
    this.registerLazyRelation(
      'modules',
      () => this.injector.get(ModuleEntityService)
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): ModuleEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
